/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import { Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import './style.scss'

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
const ModalComponent = ({ modalIsOpen, toggle, handleSubmit, history }) => {
  const { t } = useTranslation()
  const redirectCreateCammpaign = () => {
    history.push(`/create`)
  }

  return (
    <div>
      <Modal
        fade={false}
        className="modal-role"
        isOpen={modalIsOpen}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <h4>{t('login.roleSelection')}</h4>
          <div className="roles">
            <div>
              <button
                type="button"
                className="btn-success btn"
                onClick={redirectCreateCammpaign}
              >
                {t('login.artist')}
              </button>
            </div>
            <div>
              <button
                type="button"
                className="btn-success btn"
                onClick={() => handleSubmit('curator')}
              >
                {t('login.curator')}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ModalComponent
